<template>
  <v-dialog v-model="showModal" width="500" persistent scrollable>
      <v-card>
        <v-card-title class="headline">Create Question</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form @submit.prevent="saveQuestion">

            <v-text-field
              v-model="title"
              :counter="500"
              label="Title"
              v-validate="'required|max:500'"
              :error-messages="errors.collect('title')"
              data-vv-name="title"
            ></v-text-field>

            <v-select
              :items="types"
              v-model="type"
              label="Type"
              required
              v-validate="'required'"
              :error-messages="errors.collect('type')"
              data-vv-name="type"
              @input="clearOptions()"
            ></v-select>

            <div v-if="type === 'CHECK' || type === 'RADIO'">
              <v-layout row wrap align-center justify-space-between v-for="(item, index) in options" :key="index">
                <v-flex xs10>
                  <v-text-field
                    v-model="item.title"
                    :counter="190"
                    label="Enter an option"
                    type="text"
                    :key="'title' + index"
                  ></v-text-field>
                </v-flex>
                <v-flex xs2 class="text-right">
                  <v-btn color="red" fab small class="mr-0" @click="deleteOption(index)">
                    <v-icon color="white">delete</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout> 
              <v-btn color="primary" block @click="addOptions">
                Add New option
              </v-btn>
            </div>
            
            <div v-if ="type == 'LIST'">
              <hr>
              <v-text-field
                v-model="itemList"
                :counter="190"
                label="Enter an options separate with ',' "
                type="text"
              ></v-text-field>
              <v-select :items="previewList" label="Options" data-vv-name="option"></v-select>
            </div>
            <div v-if="type === 'NUMERAL'">
              <v-layout row wrap align-center justify-space-between v-for="(item, index) in options" :key="index">
                <v-flex xs10>
                  <v-text-field
                    v-model="item.title"
                    :counter="190"
                    label="Enter an title"
                    type="text"
                    :key="'title' + index"
                  ></v-text-field>
                </v-flex>
                <v-flex xs2 class="text-right">
                  <v-btn color="green" fab small class="mr-0">
                    <span class="white--text">{{item.value}}</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
            <div v-if="type === 'SMILEY'">
              <v-layout row wrap align-center justify-space-between v-for="(item, index) in options" :key="index">
                <v-flex xs10>
                  <v-text-field
                    v-model="item.title"
                    :counter="190"
                    label="Enter an title"
                    type="text"
                    :key="'title' + index"
                  ></v-text-field>
                </v-flex>
                <v-flex xs2 class="text-right">
                  <v-btn color="green" fab small class="mr-0">
                    <span class="white--text">{{item.value}}</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="closeModalQuestion">Close</v-btn>
          <v-btn color="primary" @click="saveQuestion">Save</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    roundId: {
      type: String
    }
  },
  data () {
    
    return {
      title: '',
      type: 'TEXT',
      itemList: '',
      options: [],
      types: ['NPS', 'RADIO', 'TEXT', 'SMILEY', 'LIST', 'NUMERAL', 'CHECK'],
      listDefaultNumeral: [
        {
          title: 'Totally satisfied',
          value: '5',
        },
        {
          title: 'Very satisfied',
          value: '4',
        },
        {
          title: 'Satisfied',
          value: '3',
        },
        {
          title: 'Little satisfied',
          value: '2',
        },
        {
          title: 'Not satisfied',
          value: '1',
        }
      ],
      listDefaultSmileys: [
        {
          title: 'Excellent',
          value: '5',
        },
        {
          title: 'Good',
          value: '4',
        },
        {
          title: 'Neutral',
          value: '3',
        },
        {
          title: 'Bad',
          value: '2',
        },
        {
          title: 'Very bad',
          value: '1',
        }
      ],
      
    };
  },
  computed: {
    previewList: function () {
      let list = [];
      list = this.itemList.split(',');
      this.options = list;
      return list;  
    },
  },
  methods: {
    ...mapActions(['setSnackbar', 'setLoading']),
    ...mapActions('question', [
      'callAddQuestion'
    ]),
    addOptions () {
      this.options.push({
        title: '',
        value: '' 
      });
    },
    deleteOption (index) {
      this.options.splice(index, 1);
    },
    saveQuestion () {
      this.$validator.validateAll().then(result => {
        if (result) {
          let options = [];
          for (let index = 0; index < this.options.length; index++) {
            options[index] = {
              title: this.type !== 'LIST' ? this.options[index].title : this.options[index],
              value: this.type !== 'LIST' ? this.options[index].value : null,
            };
          }
          let payload = {
            round_id: this.roundId,
            title: this.title,
            type: this.type,
            options
          };
          this.setLoading(true);
          const url = '/questions';
          
          window.axios.post(url, payload).then((response) => {
            this.setLoading(false);
            this.$emit('add-question-round', response.data.data);
            this.closeModalQuestion();
            this.resetForm();
          }).catch((error) => {
            this.$store.dispatch('setLoading', false);
          });
        } else {
          this.setSnackbar({
            show: true,
            color: 'info',
            text: 'Check the form, please.'
          });
        }

      });
      
     
    },
    closeModalQuestion () {
      this.$emit('close-modal-create');
      this.options = [];
    },
    clearOptions () {
      this.options = [];
      if (this.type === 'SMILEY') {
        this.options = this.listDefaultSmileys;
      }
      if (this.type === 'NUMERAL') {
        this.options = this.listDefaultNumeral;
      }
    },
    resetForm () {
      this.title = '';
      this.type = 'TEXT';
      this.itemList = '';
    }
  }
};
</script>
<style>
  .text-right{
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/client/questions/modals/CreateQuestion.vue